import React, { Component } from 'react';

export class HeaderFooter extends Component {

    render() {
        var { hasLangToggle } = this.props;
        var resources = this.props.langResources;

        var toggleLinks = resources.langKey == "EN" ? <span className="d-block"><span className={"text-white default-lang"}>{resources.currentLanguage + " | "}</span><a className="text-white" href="javascript:void(0)" onClick={this.props.langToggleClick} alt={resources.otherlanguage} dangerouslySetInnerHTML={{ __html: resources.otherlanguage }}></a></span> : <span className="d-block"><a className="text-white" href="javascript:void(0)" onClick={this.props.langToggleClick} alt={resources.otherlanguage}>{resources.otherlanguage + " | "}</a><span className={"text-white default-lang"} dangerouslySetInnerHTML={{ __html: resources.currentLanguage }}></span></span>;
        return (
            <div>
                <header className={"bg-dark p-3 px-5"}>
                    <div className={"row align-items-center mx-0"}>
                        <h1 className="sr-only">Cleverant</h1>
                        <div className={"CA-Deloitte-logo col-lg-9 col-9 px-0"}>
                            <a href={resources.deloitteHomeLink}><h1><span className="sr-only">Deloitte</span></h1>
                                <h1><img src={require("../images/DeloitteLogo.png")} alt="Deloitte" className={"deloitteLogo"} /></h1>
                            </a>
                        </div>
                        <div className={"CA-TradeMark col-lg-3 col-3 pull-right text-right pr-0"}>
                            {hasLangToggle ? toggleLinks : null}
                            <a href={resources.cleverantHomeLink} title="CleverAnt Logo which redirects to CleverAnt Home link"><img src={require("../images/CleverAntLogo.png")} className="cleverAntLogo" alt="CleverAnt Logo which redirects to CleverAnt Home link" /></a>
                        </div>
                    </div>
                </header>
                {this.props.children}
                <footer className={"row mx-0 p-3 px-5 bg-white"}>
                    <p className={"mb-0 pb-2"} dangerouslySetInnerHTML={{ __html: resources.footerCopyright }}></p>
                    <p dangerouslySetInnerHTML={{ __html: resources.footerDeloitteMsg }}></p>
                    <div className={"social-tab row mx-0 col-lg-12 px-0 align-items-center"}>
                        <div id="footer-social" className={"social-media-links col-s-6 col-lg-8 col-8 px-0"}>
                            <ul className={"px-0 mx-0"}>
                                <li>
                                    <a href="https://www.facebook.com/DeloitteCanada/" className="icon-facebook" target="_blank" title="Link to facebook(opens in a new window)">
                                        <i className="fa fa-facebook"><span className="sr-only">Facebook</span></i>
                                    </a>
                                </li>

                                <li>
                                    <a href="https://twitter.com/DeloitteCanada" className="icon-twitter" target="_blank">
                                        <i className={"fa fa-twitter"}><span className="sr-only">Twitter(Opens in a new window)</span></i>
                                    </a>
                                </li>

                                <li><a href="https://www.linkedin.com/company/deloitte-canada" className="icon-linkedin" target="_blank"><i className={"fa fa-linkedin"}><span className="sr-only">LinkedIn</span></i></a></li>
                                <li><a href="https://youtube.com/user/DeloitteCanada" className="icon-youtube" target="_blank"><i className={"fa fa-youtube-play"}><span className="sr-only">Youtube</span></i></a></li>
                                <li><a href="https://plus.google.com/+DeloitteCA/posts" className="icon-google-plus" target="_blank"><i className={"fa fa-google-plus"}><span className="sr-only">Google Plus</span></i> </a></li>
                            </ul>
                        </div>
                        <div className={"sponsor-logo col-s-6 col-lg-4 col-4 px-0 text-right"} id="sponsor-brand-logo">
                            <a href={resources.cleverantFooterLink} target="_blank">
                                <img src={require("../images/DeloitteNationalPartner.png")} alt="Our role with the Canadian Olympic Committee" />
                            </a>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/HeaderFooter.js